<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
    <h5 class="mb-0">Zekvo</h5>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 p-0">
        <li class="breadcrumb-item d-inline-block position-relative">
            <a routerLink="/dashboard" class="d-inline-block position-relative">
                <i class="material-symbols-outlined">home</i>
                Dashboard
            </a>
        </li>
        <li class="breadcrumb-item d-inline-block position-relative">Zekvo</li>
        <li class="breadcrumb-item d-inline-block position-relative">Zekvo List</li>
    </ol>
</div>

<div class="crm-leads-card trezo-card mb-25 border-radius d-block bg-white border-0 shadow-none">
    <div class="trezo-card-header d-sm-flex align-items-center justify-content-between">
        <div class="trezo-card-title">
            <h5 class="mb-0">Zekvo List</h5>
        </div>
        <div class="trezo-card-subtitle d-flex gap-2">
            <button
                *ngIf="authService.hasRoles([RoleEnum.ClientSuperAdmin])"
                class="add-btn d-inline-block transition fw-medium border-radius"
                type="button"
                (click)="onAddClick()"
            >
                <span class="d-inline-block position-relative">
                    <i class="material-symbols-outlined">add</i>
                    Add New Zekvo
                </span>
            </button>
            <button
                class="add-btn d-inline-block transition fw-medium border-radius"
                type="button"
                [disabled]="selectedIds().length === 0"
                (click)="exportSelectedToPdf()"
            >
                <span class="d-inline-block position-relative">
                    <i class="material-symbols-outlined">picture_as_pdf</i>
                    Export Selected as PDF ({{ selectedIds().length }})
                </span>
            </button>
        </div>
    </div>

    <div class="trezo-card-content">
        <div class="row mb-3">
            <div class="col-md-4">
                <label class="form-label">Product Name</label>
                <input
                    type="text"
                    class="form-control"
                    placeholder="Search by product name"
                    [(ngModel)]="productNameFilter"
                    (keyup.enter)="applyFilters()"
                />
            </div>
            <div class="col-md-4">
                <label class="form-label">Product Code</label>
                <input
                    type="text"
                    class="form-control"
                    placeholder="Search by product code"
                    [(ngModel)]="productCodeFilter"
                    (keyup.enter)="applyFilters()"
                />
            </div>
            <div class="col-md-4 d-flex align-items-end gap-2">
                <button class="btn btn-primary" type="button" (click)="applyFilters()">Apply</button>
                <button class="btn btn-secondary" type="button" (click)="clearFilters()">Clear</button>
            </div>
        </div>

        <div class="table-responsive">
            <table class="table table-bordered align-middle">
                <thead>
                    <tr>
                        <th style="width: 40px;">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                [checked]="allSelected"
                                (change)="toggleSelectAll()"
                            />
                        </th>
                        <th>Photo</th>
                        <th>Product Name</th>
                        <th>Product Code</th>
                        <th>Tenant</th>
                        <th>Created On</th>
                        <th *ngIf="authService.hasRoles([RoleEnum.ClientSuperAdmin])" style="width: 120px;">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of products()">
                        <td>
                            <input
                                type="checkbox"
                                class="form-check-input"
                                [checked]="isSelected(row.id!)"
                                (change)="toggleSelection(row.id!)"
                            />
                        </td>
                        <td>
                            <img
                                *ngIf="row.photoUrl"
                                [src]="getImageUrl(row.photoUrl)"
                                alt="{{ row.productName }}"
                                style="width: 80px; height: 60px; object-fit: cover; cursor: pointer; border-radius: 6px;"
                                (click)="onImageClick($event, row)"
                            />
                        </td>
                        <td>{{ row.productName }}</td>
                        <td>{{ row.productCode || '-' }}</td>
                        <td>{{ row.tenantName }}</td>
                        <td>{{ row.createdOn | date:'mediumDate' }}</td>
                        <td *ngIf="authService.hasRoles([RoleEnum.ClientSuperAdmin])">
                            <button class="btn btn-sm btn-link" type="button" (click)="onEditClick($event, row)" title="Edit">
                                <i class="material-symbols-outlined">edit</i>
                            </button>
                            <button class="btn btn-sm btn-link text-danger" type="button" (click)="onDeleteClick($event, row)" title="Delete">
                                <i class="material-symbols-outlined">delete</i>
                            </button>
                        </td>
                    </tr>
                    <tr *ngIf="products().length === 0">
                        <td colspan="7" class="text-center text-muted py-4">No Zekvo products found.</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<div class="add-new-popup" [class.active]="classApplied">
    <app-zekvo-details
        *ngIf="classApplied"
        [currentZekvoId]="zekvoId"
        (saveConfirmationEvent)="saveConfirmationEvent($event)"
        (classApplied)="classAppliedEvent($event)"
    />
</div>

<div
    class="modal fade"
    [class.show]="showImageModal"
    [style.display]="showImageModal ? 'block' : 'none'"
    tabindex="-1"
    role="dialog"
    *ngIf="showImageModal"
>
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{ selectedImageTitle }}</h4>
                <button type="button" class="btn-close" (click)="closeImageModal()" aria-label="Close"></button>
            </div>
            <div class="modal-body text-center">
                <img
                    [src]="selectedImageUrl"
                    [alt]="selectedImageTitle"
                    class="img-fluid"
                    style="max-height: 500px; border-radius: 8px"
                />
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeImageModal()">Close</button>
            </div>
        </div>
    </div>
</div>

<div
    class="modal-backdrop fade"
    [class.show]="showImageModal"
    *ngIf="showImageModal"
    (click)="closeImageModal()"
></div>
